<template>

    <FlashNotifications ref="flash"/>
    <div class="flex flex-col">
      <div class="flex flex-col" v-for="(groupedBookings, targetDate) in groupedData" :key="targetDate">
        <div class="px-5 py-3 border-b border-gray-200 bg-gray-50 w-full dark:bg-[#2A3037] dark:border-gray-500">
          <p>{{ targetDate }}</p>
        </div>
    
        <div class="flex w-full" v-for="(booking, index) in groupedBookings" :key="index">
          <div class="w-full ">
            <button type="button" v-bind:data-collapse-toggle="'booking_' + booking.id + '_' + category" class="detail-btn flex flex-wrap justify-between hover:bg-gray-100 w-full dark:hover:bg-zinc-700/80">
              <div class="md:w-4/12 flex px-5 py-5 items-center">
                <div class="flex mr-3 h-5 w-5 md:h-8 md:w-8 rounded-full flex-shrink-0" :class="booking.color"></div>
                <div class="flex flex-col items-center">
                  <span class="flex px-1 md:px-3 items-center justify-center text-sm whitespace-nowrap">{{ booking.host_ui_booking_time }}</span>
                  <p v-if="booking.is_rescheduled" class="italic font-semibold mt-1 text-sm text-slate-500/80 px-1 md:px-3">{{
                    I18N.application.bookings.upcoming.rescheduled }}</p>
                </div>
              </div>
              <div class="w-full order-last md:order-2 md:w-6/12 text-sm px-6 pt-1 pb-5 md:pt-5">
                <p class="text-left mb-2">{{ booking.attendee_name }} ({{ booking.attendee_email }})</p>
                <p class="text-left">
                  {{ booking.event_name }}
                </p>
              </div>
              <div class="flex md:w-2/12 pt-5 pl-7 pr-5 items-center md:pr-0 md:order-last">
                <svg class="mr-2 fill-gray-500 transition-all duration-300 dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                </svg>
                <span class="font-light md:font-normal text-gray-500 text-sm md:text-base dark:text-gray-400">{{ I18N.application.bookings.upcoming.details }}</span>
              </div>
            </button>
    
            <div v-bind:id="'booking_' + booking.id + '_' + category" class="hidden flex-col md:flex-row w-full px-5">
              <div class="px-1 mt-3 md:px-8 flex justify-between items-center w-full">
                <h3 class="text-xl">{{ booking.event_name }} </h3>
    
                <div class="md:w-9/12 lg:w-6/12 flex justify-end items-center space-x-3">
                  <a type="button"
                     v-if="category === 'upcoming_bookings' || category === 'recent_bookings'"
                     v-bind:href="'/bookings/' + booking.id + '/reschedule'"
                     target="_blank"
                     :disabled="booking.can_be_rescheduled === false"
                     :class="{ 'opacity-[.5] pointer-events-none ': !booking.can_be_rescheduled }"
                     class="items-center justify-center flex bg-blue-600 hover:bg-blue-700 rounded-lg text-white md:py-1 py-2 shadow-sm px-3 text-sm block text-center">
                                                        <span>
                                                          <svg class="h-4 w-4 md:h-3 md:w-3 font-light fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M126.9 142.9c62.2-62.2 162.7-62.5 225.3-1L311 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H447.5c0 0 0 0 0 0H456c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L397.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C57.2 122 39.6 150.7 28.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM0 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L169 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H32.4h-.7H24c-13.3 0-24 10.7-24 24z"/></svg></span>
                    <span class="hidden md:block px-2 py-1">{{ I18N.application.bookings.upcoming.reschedule }}</span>
                  </a>
                  <button type="button"
                          v-if="category === 'past_bookings' || category ==='canceled_bookings'"
    
                          @click="archiveBooking(booking)"
                          class="items-center justify-center flex bg-blue-600 hover:bg-blue-700 rounded-lg text-white md:py-1 py-2 shadow-sm px-3 text-sm block text-center">
                               <span>
                                 <svg class="h-5 w-5 md:h-[18px] md:w-[18px] fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM4 19V7h16l.002 12H4z"></path><path d="M14 9h-4v3H7l5 5 5-5h-3z"></path></svg>
                               </span>
                    <span class="hidden md:block px-2 py-1">{{ I18N.application.bookings.upcoming.archive }}</span>
                  </button>
                  <button type="button"
                          v-if="category === 'archived_bookings'"
                          @click="unarchiveBooking(booking)"
                          class="items-center justify-center flex bg-blue-600 hover:bg-blue-700 rounded-lg text-white md:py-1 py-2 shadow-sm px-3 text-sm block text-center">
                               <span>
                                 <svg class="h-5 w-5 md:h-4 md:w-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"/></svg>
                               </span>
                    <span class="hidden md:block px-2 py-1">{{ I18N.application.bookings.upcoming.move_back }}</span>
                  </button>
                  <button v-if="category === 'upcoming_bookings' || category === 'recent_bookings'" @click="setCancelBooking(booking)" v-bind:data-modal-target="'cancel-booking-modal_' + category" v-bind:data-modal-toggle="'cancel-booking-modal_' + category" type="button"
                          class="flex items-center justify-center hover:bg-neutral-50 rounded-lg md:py-1 py-1.5 shadow-sm px-3 md:px-5 text-sm block text-center text-blue-600 bg-white border border-blue-600 hover:bg-gray-100 dark:border-gray-400 dark:bg-[#1C2128] dark:text-gray-400 dark:hover:bg-gray-700">
                                          <span>
                                                <svg class="h-5 w-5 md:h-4 md:w-4 fill-blue-600 dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path><path d="M9 10h2v8H9zm4 0h2v8h-2z"></path></svg>
                                          </span>
                    <span class="hidden md:block px-1 py-0.5">{{ I18N.application.events.cancel }}</span>
                  </button>
                </div>
              </div>
    
              <div class="w-full md:flex md:divide-x-2 mb-5 mt-8 px-1 md:px-8">
                <div class="md:w-4/12">
                  <p class="flex items-center">
                    <svg class="w-5 h-5 fill-gray-500  dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"/>
                    </svg>
    
                    <span class="text-gray-500 text-sm ml-3 dark:text-gray-400">{{ booking.host_formatted_target_date }}</span>
                  </p>
    
                  <p class="flex items-center my-5">
                    <svg class="w-5 h-5 fill-gray-500  dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/>
                    </svg>
    
                    <span class="text-gray-500 text-sm ml-3 dark:text-gray-400">
                        {{ booking.host_ui_booking_time }}
                         ({{ booking.ui_duration }})
                    </span>
                  </p>
    
                  <div class="flex items-center break-all w-full space-x-0.5 ml-0.5">
                    <div class="w-[30px] h-auto">
                      <svg class="h-full w-6 fill-gray-500  dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path :d="locationIcon(booking)"/>
                      </svg>
                    </div>

                    <span class="text-gray-500 text-sm break-all pr-2 dark:text-gray-400" v-html="booking.formatted_location_name"></span>
                  </div>
    
                  <div class="flex items-center mt-3.5 ml-0.5">
                    <svg class="w-5 h-5 fill-gray-500  dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"></path>
                    </svg>
    
                  <span class="text-gray-500 text-sm ml-3 dark:text-gray-400"> {{ booking.titleize_host_timezone }} </span>
                  </div>
    
                  <p class="text-sm text-gray-600 mt-5 italic dark:text-gray-400">
                    {{ I18N.application.bookings.upcoming.created_on }} {{ booking.host_formatted_created_date }}
                  </p>
                  
                  <div v-if="booking.is_rescheduled" class="mt-3">
                    <hr class="border-[1px]" />
                    
                    <b class="mt-3 flex text-sm font-bold gap-2 text-zinc-500 fill-zinc-500 dark:text-zinc-300 dark:fill-zinc-300">{{ I18N.application.bookings.upcoming.former_time }}</b>
                    
                    <div class="flex text-sm mt-2.5 gap-2 text-zinc-500 fill-zinc-500 dark:text-zinc-300 dark:fill-zinc-300">
                      <div class="w-5 h-5">
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/>
                        </svg>
                      </div>
                      {{ booking.host_former_booking_details.formatted_timings }}
                    </div>
                    
                    
                    <p class="flex text-sm mt-2 gap-2 text-zinc-500 fill-zinc-500 dark:text-zinc-300 dark:fill-zinc-300">
                      <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/>
                      </svg>
                      {{ booking.host_former_booking_details.formatted_timezone }}
                    </p>
                  </div>
                </div>
                
                <hr class="border-[1px] md:hidden my-4" />
    
                <div class="md:w-8/12 md:pr-3 md:pl-7">
                  <h5 class="font-semibold text-sm text-gray-800 dark:text-gray-400">{{ I18N.application.bookings.attendee_details }}</h5>
    
                  <p class="text-gray-600 mt-2 text-sm dark:text-gray-400">
                    <span class="font-semibold">{{ I18N.application.bookings.attendee }}:</span>
                    <a class="cursor-pointer text-blue-600 hover:text-blue-700 ml-1" v-if="category !== 'external_bookings'" :href="attendee_url(booking.attendee_email)">{{ booking.attendee_name }} ({{ booking.attendee_email }})</a>
                    <span v-else>{{ booking.attendee_name }} ({{ booking.attendee_email }})</span>
                  </p>
    
    
                  <p class="text-gray-600 mt-2 text-sm dark:text-gray-400"><span class="font-semibold">{{ I18N.application.bookings.time }}:</span> {{
                    booking.attendee_ui_booking_range_with_date }} </p>
                  <p class="text-gray-600 mt-2 text-sm dark:text-gray-400"><span class="font-semibold">{{ I18N.application.bookings.timezone }}:</span> {{
                    booking.attendee_timezone_titleize }} </p>
                    
                  <p class="text-gray-600 mt-2 text-sm dark:text-gray-400"><span class="font-semibold">{{ I18N.application.bookings.location }}:</span> {{ booking.attendee_location }} </p>
    
                  <p class="mt-3 font-semibold text-gray-700 text-justify break-all dark:text-gray-400">
                    {{ I18N.application.bookings.upcoming.question_text }}
                  </p>
    
                  <p class="text-sm text-gray-600 pr-4 text-justify break-all dark:text-gray-400" v-html="booking.formatted_description">
                  </p>
                  
                  <div>
                    <div class="mt-2" v-if="booking_to_open_editor !== booking.id">
                      <div v-if="booking.internal_notes === null || booking.internal_notes === ''">
                        <p @click="toggleEditor(booking)" class="flex items-center text-blue-600 text-sm cursor-pointer">
                          <svg class="w-5 h-5 mr-1.5 mb-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="-0.5 0 25 25" fill="none">
                            <path d="M18.6375 9.04176L13.3875 14.2418C13.3075 14.3218 13.1876 14.3718 13.0676 14.3718H10.1075V11.3118C10.1075 11.1918 10.1575 11.0818 10.2375 11.0018L15.4376 5.84176" stroke="#2463eb" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.7076 11.9818V21.6618C18.7076 21.9018 18.5176 22.0918 18.2776 22.0918H2.84756C2.60756 22.0918 2.41754 21.9018 2.41754 21.6618V6.23176C2.41754 5.99176 2.60756 5.80176 2.84756 5.80176H12.4875" stroke="#2463eb" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.3863 2.90824L16.859 4.43558L20.0551 7.63167L21.5824 6.10433L18.3863 2.90824Z" stroke="#2463eb" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          
                          {{ I18N.application.bookings.add_notes }}
                        </p>
                        
                        <p class="text-gray-500 text-sm">({{ I18N.application.bookings.only_host_see }})</p>

                      </div>
                      
                      <div v-else>
                        <div class="flex items-center mt-2">
                          <p class="text-capitalize font-semibold tracking-wide mr-1.5">{{ I18N.application.bookings.meeting_notes }}</p>
                          
                          <svg @click="toggleEditor(booking)" 
                               class="w-5 h-5 fill-gray-600 cursor-pointer dark:fill-gray-400" 
                               xmlns="http://www.w3.org/2000/svg" 
                               viewBox="0 0 24 24">    
                            <path d="M 19.171875 2 C 18.448125 2 17.724375 2.275625 17.171875 2.828125 L 16 4 L 20 8 L 21.171875 6.828125 C 22.275875 5.724125 22.275875 3.933125 21.171875 2.828125 C 20.619375 2.275625 19.895625 2 19.171875 2 z M 14.5 5.5 L 3 17 L 3 21 L 7 21 L 18.5 9.5 L 14.5 5.5 z"/>
                          </svg>
                        </div>
                        
                        <div class="internal_notes mt-1" v-html="booking.internal_notes"></div>
                      </div>
                    </div>
                    
                    <div class="mt-4" v-show="booking_to_open_editor === booking.id">

                      <p class="text-capitalize font-semibold mb-2 tracking-wide">{{ I18N.application.bookings.meeting_notes }}</p>
                      
                      <textarea v-model="booking.internal_notes" class="bg-gray-50 border border-gray-300 rounded-lg appearance-none dark:text-gray-400 dark:bg-gray-700 dark:border-gray-500"></textarea>
                      
                      <div class="mt-5">

                        <a class="cursor-pointer bg-blue-600 hover:bg-blue-700 rounded-lg px-4 py-2 text-sm mt-5 text-white">
                          {{ I18N.application.bookings.update }}
                        </a>
                        
                        <a @click="closeTinyEditor" class="cursor-pointer text-gray-700 hover:text-black px-4 py-2 text-sm dark:text-gray-400 dark:hover:text-white">
                          {{ I18N.application.events.cancel }}
                        </a>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>
        </div>
    
        <div v-if="category === 'upcoming_bookings' || category === 'recent_bookings'" v-bind:id="'cancel-booking-modal_' + category" tabindex="-1" aria-hidden="true" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full">
          <div class="relative w-full h-full max-w-md md:h-auto">
            <div class="relative bg-white border rounded-lg dark:bg-[#1C2128] dark:border-gray-500">
              <button type="button" class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center" v-bind:data-modal-hide="'cancel-booking-modal_' + category">
                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                </svg>
              </button>
              <div class="px-6 py-6 lg:px-8">
                <h3 class="mb-6 text-2xl font-semibold text-gray-900 dark:text-gray-400">{{ I18N.application.bookings.upcoming.cancel_booking
                  }}</h3>
                <div class="w-full flex flex-col justify-center text-sm">
                  <p><b>{{ deleteableBooking.event_name }}</b></p>
                  <p>{{ deleteableBooking.attendee_name }} ({{ deleteableBooking.attendee_email }})</p>
                  <p>{{ deleteableBooking.host_formatted_target_date }} ({{ deleteableBooking.host_ui_booking_time }})</p>
                </div>
                <p class="py-5">{{ I18N.application.bookings.upcoming.cancel_description }}</p>
                <form v-on:submit.prevent="cancelBooking">
                  <div class="mb-6">
                    <label class="block mb-2 text-sm font-semibold text-gray-900 dark:text-gray-400">{{ I18N.application.bookings.upcoming.reason }} *</label>
                    <textarea type="text" rows="5" v-model="deleteableBooking.canceled_reason" maxlength="300" :placeholder="I18N.application.bookings.upcoming.reason_placeholder"
                              class="w-full py-2 px-3 border border-gray-300 rounded-lg appearance-none dark:bg-[#1C2128] dark:border-gray-500" required></textarea>
                  </div>
                  <div class="md:flex w-full items-center justify-center pt-6 border-t border-gray-200 rounded-b dark:border-gray-500">
                    <button type="submit" class="text-white bg-blue-600 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center w-full md:w-40 ml-0 md:ml-3 mb-3 md:mb-0">
                                       <span v-if="show_loader_on_booking_cancel">
                                            <svg aria-hidden="true" class="inline w-4 h-4 mr-1 text-gray-200 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"/>
                                            </svg>
                                            {{ I18N.application.bookings.upcoming.canceling }}
                                       </span>
    
                                        <span v-else>
                                         {{ I18N.application.bookings.upcoming.cancel_booking }}
                                       </span>
    
                    </button>
                    <button v-bind:data-modal-hide="'cancel-booking-modal_' + category" type="button" class="text-gray-600 bg-white hover:bg-gray-100 rounded-lg border border-gray-600 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 w-full md:w-40 md:order-first dark:border-gray-400 dark:bg-[#1C2128] dark:text-gray-400 dark:hover:bg-gray-700">
                      {{ I18N.application.bookings.upcoming.cancel }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"

export default {
    name: 'BookingsList',
    props: ['bookings_json', 'category'],
    mixins: [RequestMixin, Constants],
    data() {
        return {
            bookings: [],
            deleteableBooking: {},
            show_loader_on_booking_cancel: false,
            booking_to_open_editor: null,
        };
    },
    methods: {
        setCancelBooking(booking) {
            this.deleteableBooking = booking
        },

        async cancelBooking() {
            this.show_loader_on_booking_cancel = true
            let response = await this.axiosRequest('DELETE', `/api/v1/public/bookings/${this.deleteableBooking.private_key}/cancel`, {booking: {
                    canceled_reason: this.deleteableBooking.canceled_reason
                }}, false)
            if (response.js_error == false && response.response.success) {
                window.location.reload();
            }
            this.show_loader_on_booking_cancel = false
        },
        async archiveBooking(booking) {
            let response = await this.axiosRequest('PUT', `/events/bookings/${booking.id}/archive`, {}, true)

            if (response.js_error == false && response.response.success) {
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }

        },

        async unarchiveBooking(booking) {
            let response = await this.axiosRequest('PUT', `/events/bookings/${booking.id}/unarchive`, {}, true)
            if (response.js_error == false && response.response.success) {
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }

        },

        locationIcon(booking) {
            return booking.location_details.name === 'phone_call' ? 'M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z' : 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
        },

        toggleEditor(booking) {
            this.booking_to_open_editor = booking.id
        },

        closeTinyEditor() {
            this.booking_to_open_editor = null
        },

        attendee_url(attendee_email) {
            return `/attendees?attendee=${attendee_email}`;
        }
    },

    computed: {
        groupedData() {
            return this.bookings.reduce((result, item) => {
                const targetDate = item.host_formatted_target_date;
                if (!result[targetDate]) {
                    result[targetDate] = [];
                }
                result[targetDate].push(item);
                return result;
            }, {});
        }
    },
    created() {
        this.bookings = JSON.parse(this.bookings_json)
    }
};
</script>
